import { IGeoData } from 'types/geodata.types';

export interface IProcessGeoDatasPayload {
  geoDatas: IGeoData[];
}

export enum EGeoDataExportType {
  VALIDATED = 'VALIDATED',
  VERIFIED = 'VERIFIED',
}

export type TGeoDataExportType = `${EGeoDataExportType}`;

export enum EGeoDataExportFormat {
  CSV = 'CSV',
  EXCEL = 'EXCEL',
  GEOJSON = 'GEOJSON',
}

export type TGeoDataExportFormat = `${EGeoDataExportFormat}`;

export interface IExportGeoDataInput {
  geoDataId: string;
  exportType: TGeoDataExportType;
  exportFormat: TGeoDataExportFormat;
}
